import React from 'react';
import { Input, Flex, Button } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import styled from 'styled-components';

interface NumberInputProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  width?: number;
  disabled?: boolean;
  dataCy?: string;
}

const SButton = styled(Button)`
  border-radius: 0;
  outline: none;
  border: none;
  box-shadow: none;
  transition: none;

  & .ant-wave {
    display: none;
  }
`;

const NumberInput: React.FC<NumberInputProps> = ({
  value,
  onChange,
  min = 0,
  max = Infinity,
  step = 1,
  width = 60,
  disabled,
  dataCy,
}) => {
  const handleIncrement = () => {
    const newValue = Math.min(value + step, max);
    onChange(newValue);
  };

  const handleDecrement = () => {
    const newValue = Math.max(value - step, min);
    onChange(newValue);
  };

  return (
    <Flex
      align="center"
      style={{
        border: '1px solid #DEDEDE',
        borderRadius: 4,
        overflow: 'hidden',
        pointerEvents: disabled ? 'none' : undefined,
        cursor: disabled ? 'not-allowed' : undefined,
        backgroundColor: disabled ? '#F3F3F3' : '#FFFFFF',
      }}
    >
      <SButton
        icon={<MinusOutlined />}
        onClick={handleDecrement}
        style={{ background: 'none', border: 0 }}
      />
      <Input
        value={value}
        readOnly
        data-cy={dataCy}
        style={{
          width,
          textAlign: 'center',
          cursor: 'default',
          pointerEvents: 'none',
          border: 0,
          background: 'none',
        }}
      />
      <SButton
        icon={<PlusOutlined />}
        onClick={handleIncrement}
        style={{ background: 'none', border: 0 }}
      />
    </Flex>
  );
};

export default NumberInput;
